import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getResourcePresignedUploadUrl } from '../redux/actions/resources';
import { validateResourceFile, COURSE_RESOURCE_LIMIT } from '../common/resourceUploads';
import { useR2UploadQueue } from './useR2UploadQueue';

export const useResourceUploads = (courseId, { maxFiles = COURSE_RESOURCE_LIMIT } = {}) => {
    const dispatch = useDispatch();

    const requestPresign = useCallback((file, mimeType) => {
        if (!courseId) {
            return Promise.reject(new Error('No hay curso activo.'));
        }
        return dispatch(getResourcePresignedUploadUrl(courseId, {
            fileName: file.name,
            mimeType,
            size: file.size,
        }));
    }, [courseId, dispatch]);

    return useR2UploadQueue({
        validateFile: validateResourceFile,
        requestPresign,
        maxFiles,
    });
};
